var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSweet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 432 74.06",
    style: {
      enableBackground: "new 0 0 432 74.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E7DBC6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.23,30.21v-2.77c-0.04-3.78,0.51-4.87,3.39-4.64l0.16,2.26c-2.38,0.04-2.92,1.32-2.8,2.38h2.73v2.77H50.23z  M54.63,30.21v-2.77c-0.04-3.78,0.51-4.87,3.39-4.64l0.16,2.26c-2.38,0.04-2.92,1.32-2.81,2.38h2.73v2.77H54.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.36,48.76c0-2.49,0.08-5.34,0.43-7.48h2.8c-1.75,3.35-2.49,5.77-2.49,7.01c0,1.13,0.74,1.44,2.65,1.44 c1.29,0,1.6-0.78,1.6-1.79c0-5.14-5.18-14.26-5.18-19.87c0-3.47,2.06-4.91,4.52-4.91c2.03,0,3,1.21,3,3.62c0,1.48,0,4.44-0.43,7.09 h-2.57c1.75-4.25,2.26-5.65,2.26-6.7s-0.62-1.36-2.26-1.36c-1.29,0-1.6,0.78-1.6,1.79c0,4.4,5.18,15.47,5.18,19.98 c0,3.35-2.06,4.79-4.52,4.79C76.45,52.38,75.36,51.17,75.36,48.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.05,23.55h1.91l1.17,12.12l0.74,7.79h0.43l1.32-19.91h3.51l-4.99,28.44h-1.09l-2.42-19.05h-0.27 l-1.68,19.05h-1.09l-4.75-28.44h3.27l1.56,12.12l0.39,7.79h0.43L96.05,23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.12,37.42v12.04h4.21v2.53h-7.13V23.55h6.74v2.53h-3.82v10.48h2.77v0.86H114.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.92,37.42v12.04h4.21v2.53h-7.13V23.55h6.74v2.53h-3.82v10.48h2.77v0.86H127.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.62,23.55h9.39v2.53h-3.23v25.91h-2.92V26.09h-3.23V23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.71,23.55h9.39v2.53h-3.23v25.91h-2.92V26.09h-3.23V23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.15,51.99L184.14,44h-2.92l-0.51,7.99h-3.51l4.29-24.5l-1.68-3.93h3.86l4.75,28.44H185.15z M181.29,43.23 h2.73l-0.7-5.65l-0.74-7.79h-0.43L181.29,43.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.42,23.55v25.91h4.21v2.53h-7.13V23.55H197.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.02,23.55v3.16l-0.94,9.19l0.39,0.08l3.58-12.43h3.51v2.61l-0.86,0.23c-2.14,0.58-2.88,3-4.36,6.86 c-0.47,1.25-0.82,2.26-1.01,3.16l0.27,0.27l3.39-0.31l2.57,15.62h-3.16l-1.44-11.02c-0.39-3.04-0.78-3.66-1.83-3.47 c-0.08,0.51-0.12,1.01-0.12,1.56v12.93h-2.92V23.55H211.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.76,23.55v28.44h-2.92V23.55H226.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.01,51.99l-3.74-23.65h-0.47l0.54,9l0.23,14.65h-2.77V23.55h2.77l3.74,23.65h0.47l-0.55-9l-0.27-14.65h2.8 v28.44H240.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.4,30.95l-0.16-2.26c2.38-0.04,2.92-1.32,2.8-2.38h-2.73v-2.77h3.47v2.77 C252.83,30.1,252.28,31.19,249.4,30.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.36,23.55h2.45l0.39,28.44h-3l0.51-20.33h-0.43l-2.49,18.39h-0.9l-3.23-18.39h-0.39l1.05,20.33h-3.08 l0.39-28.44h2.92l3.12,18.43h0.43L279.36,23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.18,37.42v12.04h4.21v2.53h-7.13V23.55H296v2.53h-3.82v10.48h2.77v0.86H292.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.97,23.55v25.91h4.21v2.53h-7.13V23.55H305.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.65,47.82v-19.4c0-3.82,2.1-5.26,4.64-5.26c2.73,0,4.17,1.21,4.17,4.56v19.4c0,3.82-2.1,5.26-4.64,5.26 C318.13,52.38,316.65,51.17,316.65,47.82z M319.57,28.03V46.5c0,2.81,0.78,3.23,1.71,3.23c1.01,0,1.25-0.86,1.25-2.22V29.05 c0-2.8-0.74-3.23-1.52-3.23C319.84,25.81,319.57,26.67,319.57,28.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.21,23.55c3.35,0,5.3,1.36,5.3,4.91v18.27c0,3.82-2.65,5.26-5.8,5.26h-3V23.55H336.21z M335.62,26.2v23.14 h0.58c1.91,0,2.38-0.86,2.38-2.22V29.43c0-2.53-0.7-3.23-2.65-3.23H335.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.91,23.55h3.51l-4.05,20.57v7.87h-2.92v-7.91l-3.86-20.53h3.27l1.56,10.79l0.74,6.89h0.43L354.91,23.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.46,30.95l-0.16-2.26c2.38-0.04,2.92-1.32,2.8-2.38h-2.73v-2.77h3.47v2.77 C377.89,30.1,377.35,31.19,374.46,30.95z M378.87,30.95l-0.16-2.26c2.38-0.04,2.92-1.32,2.8-2.38h-2.73v-2.77h3.47v2.77 C382.29,30.1,381.75,31.19,378.87,30.95z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweet);
export default __webpack_public_path__ + "static/media/Sweet.eba8ae61c7f68f86050c57d5df98033a.svg";
export { ForwardRef as ReactComponent };